import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import FeaturedWork from "./FeaturedWork";
import Home2 from "./Home2";
import usePageMeta from "../../hooks/usePageMeta";

function Home() {
  usePageMeta(
    "Om Jaiswal | Full Stack Developer",
    "Portfolio of Om Jaiswal, a full stack developer building polished websites, web apps, and scalable APIs with clear UX, robust architecture, and thoughtful integrations."
  );

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="align-items-center align-items-lg-start gy-4 home-hero-row">
            <Col lg={7} className="home-header">
              <p className="hero-eyebrow">Om Jaiswal · Full Stack Developer</p>
              <h1 className="hero-title">
                Websites and web apps that feel clear, polished, and ready to trust.
              </h1>
              <p className="hero-lead">
                I build websites and web apps end to end with clear UX, solid
                architecture, and no handoff gaps.
              </p>

              <p className="hero-availability">
                Available for website builds, web apps, and product revamps
                where UX and engineering both matter.
              </p>

              <div className="hero-actions">
                <Button as={Link} to="/projects" className="hero-primary-btn">
                  See Selected Work
                </Button>
                <Button
                  as="a"
                  href="#project-brief"
                  variant="outline-light"
                  className="hero-secondary-btn"
                >
                  Send a Project Brief
                </Button>
              </div>

              <div className="hero-stack" aria-label="Core technologies">
                <span className="hero-stack-pill">React</span>
                <span className="hero-stack-pill">Node.js</span>
                <span className="hero-stack-pill">TypeScript</span>
                <span className="hero-stack-pill">PostgreSQL</span>
                <span className="hero-stack-pill">REST APIs</span>
                <span className="hero-stack-pill">Next.js</span>
              </div>

              <div className="hero-highlight-grid">
                <div className="hero-highlight-card">
                  <span className="hero-highlight-label">What I build</span>
                  <strong>Full stack websites, web apps, and APIs</strong>
                </div>
                <div className="hero-highlight-card">
                  <span className="hero-highlight-label">Experience in</span>
                  <strong>Healthcare, fintech, and operational products</strong>
                </div>
                <div className="hero-highlight-card">
                  <span className="hero-highlight-label">Best fit</span>
                  <strong>End-to-end product builds and revamps</strong>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="home-illustration-wrap">
                <img
                  src={homeLogo}
                  alt="Illustration of Om Jaiswal building software"
                  className="img-fluid home-illustration"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <FeaturedWork />
      <Home2 />
    </section>
  );
}

export default Home;
